import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './AddBlogDetails.css';

// Component
import AddBlogDetailsPage from '../../../components/siteadmin/AddBlogDetails/AddBlogDetails';

function AddBlogDetails({ title }) {
  return (
    <AddBlogDetailsPage title={title} />
  );
}

AddBlogDetails.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool,
    getBlogParentPage: PropTypes.any,
  }),
};

AddBlogDetails.defaultProps = {
  data: {
    loading: true,
  },
};

export default withStyles(s)(AddBlogDetails);